export default "__VITE_ASSET__xZZ1gx5h__"